export function isOverflowing(height: number, element: HTMLElement): boolean {
  console.log(element);
  return (
    height <
    ((
      element.querySelector(".position-description-detail") as
        | HTMLElement
        | undefined
    )?.offsetHeight ?? 0) +
      35
  );
}
